import { ReactElement } from 'react'

export function MasterCard(): ReactElement {
  return <img className="w-full h-full" src="https://i.imgur.com/bbPHJVe.png" />
}
